'use strict';

const ItemPickerDirective=require('../itemPickerDirective/itemPickerDirective');let

DeviationThresholdPickerDirective=class DeviationThresholdPickerDirective extends ItemPickerDirective{
get templateUrl(){return'/templates/directives/deviationThresholdPickerDirective/deviationThresholdPickerTemplate'}};


module.exports=DeviationThresholdPickerDirective;
//# sourceMappingURL=deviationThresholdPickerDirective.js.map
